<div id="app-comp-id" class="app-comp">
    <app-header class="app-comp__header"></app-header>
    <div class="app-comp__content">
        <ng-container *ngIf="authorizationService.isAuthorized$ |async ; else forbidden">
            <router-outlet></router-outlet>
        </ng-container>
        <ng-template #forbidden>
            <app-forbidden></app-forbidden>
        </ng-template>
    </div>
    <app-footer class="app-comp__footer"></app-footer>
</div>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fc0505" type = "ball-spin-clockwise" [fullScreen] = "true"></ngx-spinner>
<app-error-message [title]='"Some standard title"'
                [enableModal]="enableModal"
                [showClose]='true'
                (closeEvent)="close()"
                (showModal)="onEnableModal($event)"
                #editModal>{{ bindModal(editModal) }}
</app-error-message>
<app-confirm-dialog></app-confirm-dialog>
